<template>
  <section
    class="border-b border-17-Grey-24%"
  >
    <div
      class="px-5 py-4 flex justify-between items-center lg:px-0 max-w-[1024px] mx-auto w-full xl:max-w-[1152px] 2xl:max-w-[1140px]"
    >
      <NuxtLink
        v-if="!selectionStore.isConnectBikeStore"
        external
        to="https://www.cycle.eco/"
      >
        <IconLoader
          name="logo"
          class="h-5"
          alt="Cycle logo"
        />
      </NuxtLink>
      <NuxtLink
        v-else
        :external="true"
        to="https://connectbike.uk/"
      >
        <IconLoader
          name="connect_bike"
          class="h-5"
          alt="Connect Bike logo"
        />
      </NuxtLink>
      <LanguageSwitcher />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useSelectionStore } from '~/store/selection-store'

const selectionStore = useSelectionStore()
</script>
